export enum EnumTipoMetodoPago {
  Transferencia10DiasFechaEmision = 1,
  Transferencia20DiasFechaEmision = 2,
  Transferencia25DiasFechaEmision = 3,
  Domiciliacion10DiasFechaEmision = 4,
  Domiciliacion20DiasFechaEmision = 5,
  Domiciliacion25DiasFechaEmision = 6,
  TransferenciaDia25 = 7,
  Compensacion = 8,
  ALaVistaReciboDomiciliado = 9,
  ALaVistaTransferencia = 10,
  DomiciliacionDia15 = 11,
  DomiciliacionDia30 = 12,
  B2BDia15 = 13,
  B2BDia30 = 14,
  B2BDia60DiasFechaEmision = 15,
  DomiciliacionDia25 = 16,
  DomiciliacionDia1 = 17,
  DomiciliacionDia2 = 18,
  DomiciliacionDia3 = 19,
  DomiciliacionDia4 = 20,
  DomiciliacionDia5 = 21,
  DomiciliacionDia6 = 22,
  DomiciliacionDia7 = 23,
  DomiciliacionDia8 = 24,
  DomiciliacionDia9 = 25,
  DomiciliacionDia10 = 26,
  DomiciliacionDia11 = 27,
  DomiciliacionDia12 = 28,
  DomiciliacionDia13 = 29,
  DomiciliacionDia14 = 30,
  DomiciliacionDia16 = 32,
  DomiciliacionDia17 = 33,
  DomiciliacionDia18 = 34,
  DomiciliacionDia19 = 35,
  DomiciliacionDia20 = 36,
  DomiciliacionDia21 = 37,
  DomiciliacionDia22 = 38,
  DomiciliacionDia23 = 39,
  DomiciliacionDia24 = 40,
  DomiciliacionDia26 = 42,
  DomiciliacionDia27 = 43,
  DomiciliacionDia28 = 44,
  DomiciliacionDia29 = 45,
  DomiciliacionDia31 = 47,
  TransferenciaDia1 = 50,
  TransferenciaDia2 = 51,
  TransferenciaDia3 = 52,
  TransferenciaDia4 = 53,
  TransferenciaDia5 = 54,
  TransferenciaDia6 = 55,
  TransferenciaDia7 = 56,
  TransferenciaDia8 = 57,
  TransferenciaDia9 = 58,
  TransferenciaDia10 = 59,
  TransferenciaDia11 = 60,
  TransferenciaDia12 = 61,
  TransferenciaDia13 = 62,
  TransferenciaDia14 = 63,
  TransferenciaDia15 = 1003,
  TransferenciaDia16 = 65,
  TransferenciaDia17 = 66,
  TransferenciaDia18 = 67,
  TransferenciaDia19 = 68,
  TransferenciaDia20 = 1002,
  TransferenciaDia21 = 70,
  TransferenciaDia22 = 71,
  TransferenciaDia23 = 72,
  TransferenciaDia24 = 73,
  TransferenciaDia26 = 75,
  TransferenciaDia27 = 76,
  TransferenciaDia28 = 77,
  TransferenciaDia29 = 78,
  TransferenciaDia30 = 1001,
  TransferenciaDia31 = 80,
  B2BDia60 = 1004,
  Transferencia1DiasFechaEmision = 1004,
  Transferencia2DiasFechaEmision = 1005,
  Transferencia3DiasFechaEmision = 1006,
  Transferencia4DiasFechaEmision = 1007,
  Transferencia5DiasFechaEmision = 1008,
  Transferencia6DiasFechaEmision = 1009,
  Transferencia7DiasFechaEmision = 1010,
  Transferencia8DiasFechaEmision = 1011,
  Transferencia9DiasFechaEmision = 1012,
  Transferencia11DiasFechaEmision = 1013,
  Transferencia12DiasFechaEmision = 1014,
  Transferencia13DiasFechaEmision = 1015,
  Transferencia14DiasFechaEmision = 1016,
  Transferencia15DiasFechaEmision = 1017,
  Transferencia16DiasFechaEmision = 1018,
  Transferencia17DiasFechaEmision = 1019,
  Transferencia18DiasFechaEmision = 1020,
  Transferencia19DiasFechaEmision = 1021,
  Transferencia21DiasFechaEmision = 1022,
  Transferencia22DiasFechaEmision = 1023,
  Transferencia23DiasFechaEmision = 1024,
  Transferencia24DiasFechaEmision = 1025,
  Transferencia26DiasFechaEmision = 1026,
  Transferencia27DiasFechaEmision = 1027,
  Transferencia28DiasFechaEmision = 1028,
  Transferencia29DiasFechaEmision = 1029,
  Transferencia30DiasFechaEmision = 1030,
  Transferencia31DiasFechaEmision = 1031,
  Transferencia32DiasFechaEmision = 1032,
  Transferencia33DiasFechaEmision = 1033,
  Transferencia34DiasFechaEmision = 1034,
  Transferencia35DiasFechaEmision = 1035,
  Transferencia36DiasFechaEmision = 1036,
  Transferencia37DiasFechaEmision = 1037,
  Transferencia38DiasFechaEmision = 1038,
  Transferencia39DiasFechaEmision = 1039,
  Transferencia40DiasFechaEmision = 1040,
  Transferencia41DiasFechaEmision = 1041,
  Transferencia42DiasFechaEmision = 1042,
  Transferencia43DiasFechaEmision = 1043,
  Transferencia44DiasFechaEmision = 1044,
  Transferencia45DiasFechaEmision = 1045,
  Transferencia46DiasFechaEmision = 1046,
  Transferencia47DiasFechaEmision = 1047,
  Transferencia48DiasFechaEmision = 1048,
  Transferencia49DiasFechaEmision = 1049,
  Transferencia50DiasFechaEmision = 1050,
  Transferencia51DiasFechaEmision = 1051,
  Transferencia52DiasFechaEmision = 1052,
  Transferencia53DiasFechaEmision = 1053,
  Transferencia54DiasFechaEmision = 1054,
  Transferencia55DiasFechaEmision = 1055,
  Transferencia56DiasFechaEmision = 1056,
  Transferencia57DiasFechaEmision = 1057,
  Transferencia58DiasFechaEmision = 1058,
  Transferencia59DiasFechaEmision = 1059,
  Transferencia60DiasFechaEmision = 1060,
  Domiciliacion1DiasFechaEmision = 1061,
  Domiciliacion2DiasFechaEmision = 1062,
  Domiciliacion3DiasFechaEmision = 1063,
  Domiciliacion4DiasFechaEmision = 1064,
  Domiciliacion5DiasFechaEmision = 1065,
  Domiciliacion6DiasFechaEmision = 1066,
  Domiciliacion7DiasFechaEmision = 1067,
  Domiciliacion8DiasFechaEmision = 1068,
  Domiciliacion9DiasFechaEmision = 1069,
  Domiciliacion11DiasFechaEmision = 1070,
  Domiciliacion12DiasFechaEmision = 1071,
  Domiciliacion13DiasFechaEmision = 1072,
  Domiciliacion14DiasFechaEmision = 1073,
  Domiciliacion15DiasFechaEmision = 1074,
  Domiciliacion16DiasFechaEmision = 1075,
  Domiciliacion17DiasFechaEmision = 1076,
  Domiciliacion18DiasFechaEmision = 1077,
  Domiciliacion19DiasFechaEmision = 1078,
  Domiciliacion21DiasFechaEmision = 1079,
  Domiciliacion22DiasFechaEmision = 1080,
  Domiciliacion23DiasFechaEmision = 1081,
  Domiciliacion24DiasFechaEmision = 1082,
  Domiciliacion26DiasFechaEmision = 1083,
  Domiciliacion27DiasFechaEmision = 1084,
  Domiciliacion28DiasFechaEmision = 1085,
  Domiciliacion29DiasFechaEmision = 1086,
  Domiciliacion30DiasFechaEmision = 1087,
  Domiciliacion31DiasFechaEmision = 1088,
  Domiciliacion32DiasFechaEmision = 1089,
  Domiciliacion33DiasFechaEmision = 1090,
  Domiciliacion34DiasFechaEmision = 1091,
  Domiciliacion35DiasFechaEmision = 1092,
  Domiciliacion36DiasFechaEmision = 1093,
  Domiciliacion37DiasFechaEmision = 1094,
  Domiciliacion38DiasFechaEmision = 1095,
  Domiciliacion39DiasFechaEmision = 1096,
  Domiciliacion40DiasFechaEmision = 1097,
  Domiciliacion41DiasFechaEmision = 1098,
  Domiciliacion42DiasFechaEmision = 1099,
  Domiciliacion43DiasFechaEmision = 1100,
  Domiciliacion44DiasFechaEmision = 1101,
  Domiciliacion45DiasFechaEmision = 1102,
  Domiciliacion46DiasFechaEmision = 1103,
  Domiciliacion47DiasFechaEmision = 1104,
  Domiciliacion48DiasFechaEmision = 1105,
  Domiciliacion49DiasFechaEmision = 1106,
  Domiciliacion50DiasFechaEmision = 1107,
  Domiciliacion51DiasFechaEmision = 1108,
  Domiciliacion52DiasFechaEmision = 1109,
  Domiciliacion53DiasFechaEmision = 1110,
  Domiciliacion54DiasFechaEmision = 1111,
  Domiciliacion55DiasFechaEmision = 1112,
  Domiciliacion56DiasFechaEmision = 1113,
  Domiciliacion57DiasFechaEmision = 1114,
  Domiciliacion58DiasFechaEmision = 1115,
  Domiciliacion59DiasFechaEmision = 1116,
  Domiciliacion60DiasFechaEmision = 1117,
  Compensacion1DiasFechaEmision = 1118,
  Compensacion2DiasFechaEmision = 1119,
  Compensacion3DiasFechaEmision = 1120,
  Compensacion4DiasFechaEmision = 1121,
  Compensacion5DiasFechaEmision = 1122,
  Compensacion6DiasFechaEmision = 1123,
  Compensacion7DiasFechaEmision = 1124,
  Compensacion8DiasFechaEmision = 1125,
  Compensacion9DiasFechaEmision = 1126,
  Compensacion10DiasFechaEmision = 1127,
  Compensacion11DiasFechaEmision = 1128,
  Compensacion12DiasFechaEmision = 1129,
  Compensacion13DiasFechaEmision = 1130,
  Compensacion14DiasFechaEmision = 1131,
  Compensacion15DiasFechaEmision = 1132,
  Compensacion16DiasFechaEmision = 1133,
  Compensacion17DiasFechaEmision = 1134,
  Compensacion18DiasFechaEmision = 1135,
  Compensacion19DiasFechaEmision = 1136,
  Compensacion20DiasFechaEmision = 1137,
  Compensacion21DiasFechaEmision = 1138,
  Compensacion22DiasFechaEmision = 1139,
  Compensacion23DiasFechaEmision = 1140,
  Compensacion24DiasFechaEmision = 1141,
  Compensacion25DiasFechaEmision = 1142,
  Compensacion26DiasFechaEmision = 1143,
  Compensacion27DiasFechaEmision = 1144,
  Compensacion28DiasFechaEmision = 1145,
  Compensacion29DiasFechaEmision = 1146,
  Compensacion30DiasFechaEmision = 1147,
  DomiciliacionDia6o5DiasNaturalesFE = 1148,
  DomiciliacionDia7o5DiasNaturalesFE = 1149,
  DomiciliacionDia8o5DiasNaturalesFE = 1150,
  DomiciliacionDia9o5DiasNaturalesFE = 1151,
  DomiciliacionDia10o5DiasNaturalesFE = 1152,
  DomiciliacionDia11o5DiasNaturalesFE = 1153,
  DomiciliacionDia12o5DiasNaturalesFE = 1154,
  DomiciliacionDia13o5DiasNaturalesFE = 1155,
  DomiciliacionDia14o5DiasNaturalesFE = 1156,
  DomiciliacionDia15o5DiasNaturalesFE = 1157,
  DomiciliacionDia16o5DiasNaturalesFE = 1158,
  DomiciliacionDia17o5DiasNaturalesFE = 1159,
  DomiciliacionDia18o5DiasNaturalesFE = 1160,
  DomiciliacionDia19o5DiasNaturalesFE = 1161,
  DomiciliacionDia20o5DiasNaturalesFE = 1162,
  DomiciliacionDia21o5DiasNaturalesFE = 1163,
  DomiciliacionDia22o5DiasNaturalesFE = 1164,
  DomiciliacionDia23o5DiasNaturalesFE = 1165,
  DomiciliacionDia24o5DiasNaturalesFE = 1166,
  DomiciliacionDia25o5DiasNaturalesFE = 1167,
  DomiciliacionDia26o5DiasNaturalesFE = 1168,
  DomiciliacionDia27o5DiasNaturalesFE = 1169,
  DomiciliacionDia28o5DiasNaturalesFE = 1170,
  DomiciliacionDia29o5DiasNaturalesFE = 1171,
  DomiciliacionDia30o5DiasNaturalesFE = 1172,
  DomiciliacionDia31o5DiasNaturalesFE = 1173,
  TransferenciaDia6o5DiasNaturalesFE = 1174,
  TransferenciaDia7o5DiasNaturalesFE = 1175,
  TransferenciaDia8o5DiasNaturalesFE = 1176,
  TransferenciaDia9o5DiasNaturalesFE = 1177,
  TransferenciaDia10o5DiasNaturalesFE = 1178,
  TransferenciaDia11o5DiasNaturalesFE = 1179,
  TransferenciaDia12o5DiasNaturalesFE = 1180,
  TransferenciaDia13o5DiasNaturalesFE = 1181,
  TransferenciaDia14o5DiasNaturalesFE = 1182,
  TransferenciaDia15o5DiasNaturalesFE = 1183,
  TransferenciaDia16o5DiasNaturalesFE = 1184,
  TransferenciaDia17o5DiasNaturalesFE = 1185,
  TransferenciaDia18o5DiasNaturalesFE = 1186,
  TransferenciaDia19o5DiasNaturalesFE = 1187,
  TransferenciaDia20o5DiasNaturalesFE = 1188,

  TransferenciaDia21o5DiasNaturalesFE = 1189,

  TransferenciaDia22o5DiasNaturalesFE = 1190,

  TransferenciaDia23o5DiasNaturalesFE = 1191,

  TransferenciaDia24o5DiasNaturalesFE = 1192,

  TransferenciaDia25o5DiasNaturalesFE = 1193,

  TransferenciaDia26o5DiasNaturalesFE = 1194,

  TransferenciaDia27o5DiasNaturalesFE = 1195,

  TransferenciaDia28o5DiasNaturalesFE = 1196,

  TransferenciaDia29o5DiasNaturalesFE = 1197,

  TransferenciaDia30o5DiasNaturalesFE = 1198,

  TransferenciaDia31o5DiasNaturalesFE = 1199,

  DomiciliacionDia1MesSiguienteFE = 1200,

  DomiciliacionDia2MesSiguienteFE = 1201,

  DomiciliacionDia3MesSiguienteFE = 1202,

  DomiciliacionDia4MesSiguienteFE = 1203,

  DomiciliacionDia5MesSiguienteFE = 1204,

  DomiciliacionDia6MesSiguienteFE = 1205,

  DomiciliacionDia7MesSiguienteFE = 1206,

  DomiciliacionDia8MesSiguienteFE = 1207,

  DomiciliacionDia9MesSiguienteFE = 1208,

  DomiciliacionDia10MesSiguienteFE = 1209,

  DomiciliacionDia11MesSiguienteFE = 1210,

  DomiciliacionDia12MesSiguienteFE = 1211,

  DomiciliacionDia13MesSiguienteFE = 1212,

  DomiciliacionDia14MesSiguienteFE = 1213,

  DomiciliacionDia15MesSiguienteFE = 1214,

  DomiciliacionDia16MesSiguienteFE = 1215,

  DomiciliacionDia17MesSiguienteFE = 1216,

  DomiciliacionDia18MesSiguienteFE = 1217,

  DomiciliacionDia19MesSiguienteFE = 1218,

  DomiciliacionDia20MesSiguienteFE = 1219,

  DomiciliacionDia21MesSiguienteFE = 1220,

  DomiciliacionDia22MesSiguienteFE = 1221,

  DomiciliacionDia23MesSiguienteFE = 1222,

  DomiciliacionDia24MesSiguienteFE = 1223,

  DomiciliacionDia25MesSiguienteFE = 1224,

  DomiciliacionDia26MesSiguienteFE = 1225,

  DomiciliacionDia27MesSiguienteFE = 1226,

  DomiciliacionDia28MesSiguienteFE = 1227,

  DomiciliacionDia29MesSiguienteFE = 1228,

  DomiciliacionDia30MesSiguienteFE = 1229,

  DomiciliacionDia31MesSiguienteFE = 1230,

  TransferenciaDia1MesSiguienteFE = 1231,

  TransferenciaDia2MesSiguienteFE = 1232,

  TransferenciaDia3MesSiguienteFE = 1233,

  TransferenciaDia4MesSiguienteFE = 1234,

  TransferenciaDia5MesSiguienteFE = 1235,

  TransferenciaDia6MesSiguienteFE = 1236,

  TransferenciaDia7MesSiguienteFE = 1237,

  TransferenciaDia8MesSiguienteFE = 1238,

  TransferenciaDia9MesSiguienteFE = 1239,

  TransferenciaDia10MesSiguienteFE = 1240,

  TransferenciaDia11MesSiguienteFE = 1241,

  TransferenciaDia12MesSiguienteFE = 1242,

  TransferenciaDia13MesSiguienteFE = 1243,

  TransferenciaDia14MesSiguienteFE = 1244,

  TransferenciaDia15MesSiguienteFE = 1245,

  TransferenciaDia16MesSiguienteFE = 1246,

  TransferenciaDia17MesSiguienteFE = 1247,

  TransferenciaDia18MesSiguienteFE = 1248,

  TransferenciaDia19MesSiguienteFE = 1249,

  TransferenciaDia20MesSiguienteFE = 1250,

  TransferenciaDia21MesSiguienteFE = 1251,

  TransferenciaDia22MesSiguienteFE = 1252,

  TransferenciaDia23MesSiguienteFE = 1253,

  TransferenciaDia24MesSiguienteFE = 1254,

  TransferenciaDia25MesSiguienteFE = 1255,

  TransferenciaDia26MesSiguienteFE = 1256,

  TransferenciaDia27MesSiguienteFE = 1257,

  TransferenciaDia28MesSiguienteFE = 1258,

  TransferenciaDia29MesSiguienteFE = 1259,

  TransferenciaDia30MesSiguienteFE = 1260,

  TransferenciaDia31MesSiguienteFE = 1261,

  Domiciliacion1DiasFechaConsumo = 1262,

  Domiciliacion2DiasFechaConsumo = 1263,

  Domiciliacion3DiasFechaConsumo = 1264,

  Domiciliacion4DiasFechaConsumo = 1265,

  Domiciliacion5DiasFechaConsumo = 1266,

  Domiciliacion6DiasFechaConsumo = 1267,

  Domiciliacion7DiasFechaConsumo = 1268,

  Domiciliacion8DiasFechaConsumo = 1269,

  Domiciliacion9DiasFechaConsumo = 1270,

  Domiciliacion10DiasFechaConsumo = 1271,

  Domiciliacion11DiasFechaConsumo = 1272,

  Domiciliacion12DiasFechaConsumo = 1273,

  Domiciliacion13DiasFechaConsumo = 1274,

  Domiciliacion14DiasFechaConsumo = 1275,

  Domiciliacion15DiasFechaConsumo = 1276,

  Domiciliacion16DiasFechaConsumo = 1277,

  Domiciliacion17DiasFechaConsumo = 1278,

  Domiciliacion18DiasFechaConsumo = 1279,

  Domiciliacion19DiasFechaConsumo = 1280,

  Domiciliacion20DiasFechaConsumo = 1281,

  Domiciliacion21DiasFechaConsumo = 1282,

  Domiciliacion22DiasFechaConsumo = 1283,

  Domiciliacion23DiasFechaConsumo = 1284,

  Domiciliacion24DiasFechaConsumo = 1285,

  Domiciliacion25DiasFechaConsumo = 1286,

  Domiciliacion26DiasFechaConsumo = 1287,

  Domiciliacion27DiasFechaConsumo = 1288,

  Domiciliacion28DiasFechaConsumo = 1289,

  Domiciliacion29DiasFechaConsumo = 1290,

  Domiciliacion30DiasFechaConsumo = 1291,

  Domiciliacion31DiasFechaConsumo = 1292,

  Domiciliacion32DiasFechaConsumo = 1293,

  Domiciliacion33DiasFechaConsumo = 1294,

  Domiciliacion34DiasFechaConsumo = 1295,

  Domiciliacion35DiasFechaConsumo = 1296,

  Domiciliacion36DiasFechaConsumo = 1297,

  Domiciliacion37DiasFechaConsumo = 1298,

  Domiciliacion38DiasFechaConsumo = 1299,

  Domiciliacion39DiasFechaConsumo = 1300,

  Domiciliacion40DiasFechaConsumo = 1301,

  Domiciliacion41DiasFechaConsumo = 1302,

  Domiciliacion42DiasFechaConsumo = 1303,

  Domiciliacion43DiasFechaConsumo = 1304,

  Domiciliacion44DiasFechaConsumo = 1305,

  Domiciliacion45DiasFechaConsumo = 1306,

  Domiciliacion46DiasFechaConsumo = 1307,

  Domiciliacion47DiasFechaConsumo = 1308,

  Domiciliacion48DiasFechaConsumo = 1309,

  Domiciliacion49DiasFechaConsumo = 1310,

  Domiciliacion50DiasFechaConsumo = 1311,

  Domiciliacion51DiasFechaConsumo = 1312,

  Domiciliacion52DiasFechaConsumo = 1313,

  Domiciliacion53DiasFechaConsumo = 1314,

  Domiciliacion54DiasFechaConsumo = 1315,

  Domiciliacion55DiasFechaConsumo = 1316,

  Domiciliacion56DiasFechaConsumo = 1317,

  Domiciliacion57DiasFechaConsumo = 1318,

  Domiciliacion58DiasFechaConsumo = 1319,

  Domiciliacion59DiasFechaConsumo = 1320,

  Domiciliacion60DiasFechaConsumo = 1321,

  Transferencia1DiasFechaConsumo = 1322,

  Transferencia2DiasFechaConsumo = 1323,

  Transferencia3DiasFechaConsumo = 1324,

  Transferencia4DiasFechaConsumo = 1325,

  Transferencia5DiasFechaConsumo = 1326,

  Transferencia6DiasFechaConsumo = 1327,

  Transferencia7DiasFechaConsumo = 1328,

  Transferencia8DiasFechaConsumo = 1329,

  Transferencia9DiasFechaConsumo = 1330,

  Transferencia10DiasFechaConsumo = 1331,

  Transferencia11DiasFechaConsumo = 1332,

  Transferencia12DiasFechaConsumo = 1333,

  Transferencia13DiasFechaConsumo = 1334,

  Transferencia14DiasFechaConsumo = 1335,

  Transferencia15DiasFechaConsumo = 1336,

  Transferencia16DiasFechaConsumo = 1337,

  Transferencia17DiasFechaConsumo = 1338,

  Transferencia18DiasFechaConsumo = 1339,

  Transferencia19DiasFechaConsumo = 1340,

  Transferencia20DiasFechaConsumo = 1341,

  Transferencia21DiasFechaConsumo = 1342,

  Transferencia22DiasFechaConsumo = 1343,

  Transferencia23DiasFechaConsumo = 1344,

  Transferencia24DiasFechaConsumo = 1345,

  Transferencia25DiasFechaConsumo = 1346,

  Transferencia26DiasFechaConsumo = 1347,

  Transferencia27DiasFechaConsumo = 1348,

  Transferencia28DiasFechaConsumo = 1349,

  Transferencia29DiasFechaConsumo = 1350,

  Transferencia30DiasFechaConsumo = 1351,

  Transferencia31DiasFechaConsumo = 1352,

  Transferencia32DiasFechaConsumo = 1353,

  Transferencia33DiasFechaConsumo = 1354,

  Transferencia34DiasFechaConsumo = 1355,

  Transferencia35DiasFechaConsumo = 1356,

  Transferencia36DiasFechaConsumo = 1357,

  Transferencia37DiasFechaConsumo = 1358,

  Transferencia38DiasFechaConsumo = 1359,

  Transferencia39DiasFechaConsumo = 1360,

  Transferencia40DiasFechaConsumo = 1361,

  Transferencia41DiasFechaConsumo = 1362,

  Transferencia42DiasFechaConsumo = 1363,

  Transferencia43DiasFechaConsumo = 1364,

  Transferencia44DiasFechaConsumo = 1365,

  Transferencia45DiasFechaConsumo = 1366,

  Transferencia46DiasFechaConsumo = 1367,

  Transferencia47DiasFechaConsumo = 1368,

  Transferencia48DiasFechaConsumo = 1369,

  Transferencia49DiasFechaConsumo = 1370,

  Transferencia50DiasFechaConsumo = 1371,

  Transferencia51DiasFechaConsumo = 1372,

  Transferencia52DiasFechaConsumo = 1373,

  Transferencia53DiasFechaConsumo = 1374,

  Transferencia54DiasFechaConsumo = 1375,

  Transferencia55DiasFechaConsumo = 1376,

  Transferencia56DiasFechaConsumo = 1377,

  Transferencia57DiasFechaConsumo = 1378,

  Transferencia58DiasFechaConsumo = 1379,

  Transferencia59DiasFechaConsumo = 1380,

  Transferencia60DiasFechaConsumo = 1381,

  TransferenciaDia5DosMesesSiguientesFE = 1382,

  DomiciliacionDia30DosMesesSiguientesFF = 1383,

  Transferencia65DiasFechaEmision = 1384,

  Transferencia65DiasFechaConsumo = 1385,

  TransferenciaDia15con5DiasAntelacion = 1386,

  TransferenciaDia20con5DiasAntelacion = 1387,

  TransferenciaDia30con5DiasAntelacion = 1388,

  TransferenciaDia15con10DiasAntelacion = 1389,

  TransferenciaDia20con10DiasAntelacion = 1390,

  TransferenciaDia30con10DiasAntelacion = 1391,

  TransferenciaDia20con15DiasAntelacion = 1392,

  TransferenciaDia30con15DiasAntelacion = 1393,

  DomiciliacionDia15con5DiasAntelacion = 1394,

  DomiciliacionDia20con5DiasAntelacion = 1395,

  DomiciliacionDia30con5DiasAntelacion = 1396,

  DomiciliacionDia15con10DiasAntelacion = 1397,

  DomiciliacionDia20con10DiasAntelacion = 1398,

  DomiciliacionDia30con10DiasAntelacion = 1399,

  DomiciliacionDia20con15DiasAntelacion = 1400,

  DomiciliacionDia30con15DiasAntelacion = 1401,

  TransferenciaDia1DosMesesFechaFactura = 1402,
  
  TransferenciaDia25DosMesesFechaFactura = 1403
}
